import {useLayout} from "../../Framework/Providers/LayoutProvider";
import BasicPageHeader from "../../Framework/Components/LayoutScaffold/BasicPageHeader";
import React, {useEffect, useRef, useState} from "react";
import Button from "../../Framework/Components/Buttons/Button";
import {ColourMod} from "../../Framework/Data/Enums/LayoutEnums";
import ImportCsvModal from "./Modals/ImportCsvModal";
import ImportVcfModal from "./Modals/ImportVcfModal";
import SendsAdminNavigation from "../Sends/SendsAdminNavigation";
import FullWidthSidebar from "../../Framework/Components/PageLayouts/FullWidthSidebar";
import DropdownMenu from "../../Framework/Components/DropdownMenus/DropdownMenu";
import ItemMenuEntry from "../../Framework/Components/Navigation/ItemMenuEntry";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsisVertical, faFileImport} from "@fortawesome/pro-solid-svg-icons";
import AddressImporterForm from "./Components/AddressImporterForm";

const AddressImporter = () => {
    const { isSmall, isMedium, isLarge } = useLayout();

    const [ addressData, setAddressData ] = useState<any>(null);

    const [ importCsvOpen, setImportCsvOpen ] = useState<boolean>(false);
    const [ importVcfOpen, setImportVcfOpen ] = useState<boolean>(false);

    const addressImporterRef = useRef<any>();

    const HandleFileChange = (data: any) => {
        setAddressData(data);
        setImportCsvOpen(false);
        setImportVcfOpen(false);
    }

    const HandleSave = () => {
       // console.log('AddressImporter Save Callback');
    }

    const PageActions = () => {
        return (
            <div className={'flex-row flex-gap-sm ml-a'} style={{width: 'auto'}} >
                <Button colour={ColourMod.Primary} onClick={() => setImportCsvOpen(true)} squared={true} title={'Import CSV'} />
                <Button colour={ColourMod.Primary} onClick={() => setImportVcfOpen(true)} squared={true} title={'Import VCF'} />
            </div>
        )
    }

    useEffect(() => {
        document.title = 'Address Importer'
    }, []);

    return (
        <FullWidthSidebar
            ref={addressImporterRef}
            navigationComponent={
                <SendsAdminNavigation
                    title={'Address Importer'}
                    addonContent={
                        <div className={'section-navigation-header-collapsed-addon'}>
                            {isMedium && !isLarge &&  (
                                <PageActions />
                            )}

                            {!isMedium && (
                                <>
                                    <Button
                                        squared={true}
                                        title={'Import'}
                                        extraClass={'address-import-menu'}
                                        showArrow={isMedium}
                                        icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
                                        iconOnly={!isMedium}
                                    />
                                    <DropdownMenu target={['address-import-menu']} forcedZIndexNumber={200000}>
                                        <ItemMenuEntry title={'Import CSV'} callback={() => setImportCsvOpen(true)} icon={<FontAwesomeIcon icon={faFileImport} fixedWidth={true} />} />
                                        <ItemMenuEntry title={'Import VCF'} callback={() => setImportVcfOpen(true)} icon={<FontAwesomeIcon icon={faFileImport} fixedWidth={true} />} />
                                    </DropdownMenu>
                                </>
                            )}
                        </div>
                    }
                />
            }
            extraContentClass={`flex-column `}
        >
            {isLarge && (
                <BasicPageHeader title={'Address Importer'}>
                    <PageActions />
                </BasicPageHeader>
            )}

            <AddressImporterForm
                addressData={addressData}
                savedCallback={() => HandleSave()}
                removeCallback={() => setAddressData(null)}
            />

            {importCsvOpen && (
                <ImportCsvModal
                    visible={importCsvOpen}
                    closeCallback={() => setImportCsvOpen(false) }
                    actionedCallback={(file: any) => HandleFileChange(file)}
                    forwardData={true}
                />
            )}

            {importVcfOpen && (
                <ImportVcfModal
                    visible={importVcfOpen}
                    closeCallback={() => setImportVcfOpen(false) }
                    actionedCallback={(file: any) => HandleFileChange(file)}
                    forwardData={true}
                />
            )}
        </FullWidthSidebar>
    )
}

export default AddressImporter
